module.exports = __webpack_public_path__ + "static/media/download_icon.f1a8e4f7.svg";